import {Pipe, Injectable, PipeTransform} from '@angular/core'
import pluralize from 'pluralize'

@Pipe({
  name: 'pluralize',
  pure: true
})
@Injectable()
export class PluralizePipe implements PipeTransform {
  transform(word: string, size: number): any {
    return pluralize(word, size)
  }
}
export default PluralizePipe
